/* eslint-disable @typescript-eslint/no-explicit-any */
import { IMappedGroupSchedule } from 'entities/types';

export const isMappedGroupSchedule = (
  object: any,
): object is IMappedGroupSchedule => !('groupsTags' in object);
